let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("biyCl")).then(() => parcelRequire('84Vza'));